console.log("Bundle builder");

document.addEventListener("cart:updated", function (evt) {
    console.log(evt);
    const cart = evt.detail.cart;

    if(cart?.items_removed) {
        window.location.reload();
    }
});

document.addEventListener("DOMContentLoaded", function() {
    //Init cart instance
    let cartInstance, refreshCart;
    for(const instance of Shopify.theme.sections.instances) {
        if(instance.container.classList.contains('quick-cart')) {
          cartInstance = instance;
        //   refreshCart = instance.refreshQuickCart;
          refreshCart = instance.reloadQuickCart;
          openCart = instance.openQuickCart;
          break;
        }
    }
    const bundleInner = document.querySelector('.bundle-section-inner');
    const backButton = document.querySelector('.bundle-back-button');
    const bundleTitle = document.querySelector('.bundle-header h2');
    const bundleNote = document.querySelector('.bundle-note');
    const bundleGrid = document.querySelector('.grid-collection-bundle');
    const nextBtn = document.querySelector('.bundle-step-level-btn');
    const bundleDiscountDOM = document.querySelector('.bundle-discounts');
    const totalSavings = document.querySelector('#bundle-total-savings span');
    const discountUnlocked = document.querySelector('#bundle-discount-unlocked');
    const removeBtns = document.querySelectorAll('.remove-bundle-product');
    const progressBar = document.querySelector('.progress-bar');
    const progressBarMobile = document.querySelector('.progress-bar-mobile');

    let bundleSidebar = document.querySelector('.bundle-sidebar');
    let bundleStepActive = document.querySelector('.bundle-step.active');
    let bundleSteps = document.querySelectorAll('.bundle-step');
    let bundleSizeRadios = document.querySelectorAll('input[name="choose-size"]');
    let quickViewBtn = document.querySelectorAll('.quick-view-product-item');
    let sizeRadiosArr = [], productVariantIDs = [], removeBtnsArr = [], quickViewBtnArr = [];
    let totalPricing = 0, savings = 0, progressData = 0, progressDataMobile = 0;
    let choosenSize, productsLeft, totalPricingFormat;

    //Sidebar levels
    const sidebarLevelsUL = bundleSidebar.querySelector('.bundle-product-levels ul.desktop-progress');
    const sidebarLevels = bundleSidebar.querySelectorAll('.bundle-product-levels ul.desktop-progress li');
    const sidebarLevelsULMobile = bundleSidebar.querySelector('.bundle-product-levels ul.mobile-progress');
    const sidebarLevelsMobile = bundleSidebar.querySelectorAll('.bundle-product-levels ul.mobile-progress li');

    //Mobile 
    const openBundleSidebarMobile = document.querySelector('.bundle-step-heading');
    const mobileFilter = document.querySelector('#select-collection-filter');
    
    if(typeof openBundleSidebarMobile != 'undefined' && openBundleSidebarMobile != null) {
        openBundleSidebarMobile.addEventListener('click', function(){
            bundleSidebar.classList.toggle('open');
        });        
    }
    
    if(bundleSizeRadios.length > 0) {
        bundleSizeRadios.forEach(function(el, index) {
            sizeRadiosArr[index] = el;

            sizeRadiosArr[index].addEventListener("change", function() {
                choosenSize = this.value;
                this.checked = false;
                bundleSteps.forEach(function(el) {
                    if(el.dataset.step == 2) {
                        bundleGrid.classList.add(choosenSize);
                        bundleStepActive.classList.remove('active');
                        bundleStepActive = el;
                        el.classList.add('active');
                        bundleSidebar.classList.add('active');
                        bundleTitle.innerText = bundleTitle.dataset.altTitle || 'Choose your products';
                        backButton.classList.add('active');
                        bundleInner.classList.remove('bundle-step-1');
                        bundleInner.classList.add('bundle-step-2');
                    }
                });
            });
        });

        nextBtn.addEventListener("click", function(e) {
            e.preventDefault();

            bundleSteps.forEach(function(el) {
                if(el.dataset.step == 2) {
                    bundleStepActive.classList.remove('active');
                    el.classList.add('active');                    
                }
            });
        });
    }

    // Products
    const bundleProducts = document.querySelectorAll('input[name="bundle-product"]');
    const productsInputArr = [];
    let choosenProducts = [];
    let removeIndex;

    if(bundleProducts.length > 0) {
        bundleProducts.forEach(function(prod, index) {
            productsInputArr[index] = prod;

            productsInputArr[index].addEventListener("change", function() {
                const inputElm = this;
                if(this.checked) {
                    choosenProducts.push(this);
                    
                    if(choosenProducts.length > 4) {
                        bundleProducts.forEach(function(el) {
                            if(!el.checked) {
                                el.disabled = true;
                            }
                        });
                    }
                    
                    renderProductInfoBundle(this);
                } else {
                    const findEl = (element) => element === inputElm;
                    removeIndex = choosenProducts.findIndex(findEl);
                    choosenProducts.splice(removeIndex, 1);
                    
                    removeProductInfoBundle(removeIndex);
                    if(choosenProducts.length < 5) {
                        bundleProducts.forEach(function(el) {
                            if(el.disabled) {
                                el.disabled = false;
                            }
                        });
                    }
                }
                
                if(choosenProducts.length < 3) {
                    if(nextBtn.disabled != true) {
                        nextBtn.setAttribute("disabled", true);
                    }
                    productsLeft = 3 - choosenProducts.length;
                    if(bundleNote.classList.contains('hidden')) {
                        bundleNote.classList.remove('hidden');
                    }
                    
                    bundleNote.innerText = bundleNote.dataset.translation.replace('[quantity]', productsLeft);
                    // bundleNote.innerText = "Add at least " + productsLeft + " products to unlock bundle pricing";
                    nextBtn.innerHTML = nextBtn.dataset.translation.replace('[quantity]', productsLeft);
                    // nextBtn.innerHTML = "Add " + productsLeft + " products";
                } else {
                    bundleNote.classList.add('hidden');
                    if(nextBtn.disabled == true) {
                        nextBtn.removeAttribute("disabled");
                    }
                    totalPricingFormat = window.theme.moneyFormat.replace("{{amount}}", totalPricing.toFixed(2));
                    const finalButtonTranslation = nextBtn.dataset.translationFinal;
                    nextBtn.innerHTML = "<span>"+ finalButtonTranslation +"</span><span>" + totalPricingFormat + "</span>";
                }
            });
        });
    }

    backButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        if(choosenProducts.length > 0) {
            choosenProducts.forEach(function(el, index) {
                el.checked = false;
                
                sidebarLevels[index].classList.remove('active');
                sidebarLevelsMobile[index].classList.remove('active');
                const img = sidebarLevels[index].querySelector('.bundle-product-info img');
                const name = sidebarLevels[index].querySelector('.bundle-product-meta-info h5');
                const price = sidebarLevels[index].querySelector('.bundle-product-meta-info .bundle-product-price');

                img.setAttribute('src', '');
                name.innerText = '';
                price.innerHTML = '';

                productVariantIDs.splice(index, 1);
            });

            choosenProducts = [];
        }

        sidebarLevelsUL.dataset.progress = 0;
        sidebarLevelsULMobile.dataset.progress = 0;
        progressData = 0;
        progressDataMobile = 0;
        progressBar.style.height = "0px";
        progressBarMobile.style.width = "0%";

        bundleStepActive.classList.remove("active");
        bundleStepActive = document.querySelector(".bundle-choose-size");
        bundleStepActive.classList.add('active');
        
        bundleSidebar.classList.remove('active');
        bundleTitle.innerText = bundleTitle.dataset.title || 'Select a bundle size';
        bundleGrid.classList.remove(choosenSize);

        bundleInner.classList.remove('bundle-step-2');
        bundleInner.classList.add('bundle-step-1');
        
        backButton.classList.remove('active');
        if(nextBtn.disabled != true) {
            nextBtn.setAttribute("disabled", true);
        }
        
        if(bundleNote.classList.contains('hidden')) {
            bundleNote.classList.remove('hidden');
        }

        if(bundleDiscountDOM.classList.contains('active')) {
            bundleDiscountDOM.classList.remove('active');
        }
        bundleNote.innerText = bundleNote.dataset.translation.replace('[quantity]', 3);
        // "Add at least 3 products to unlock bundle pricing";
        nextBtn.innerHTML = nextBtn.dataset.translation.replace('[quantity]', 3);
        // nextBtn.innerHTML = "Add 3 products";
    });

    // Render product info

    function renderProductInfoBundle(data) {
        let finalPrice, progress;
        totalPricing = 0;
        const positionIndex = choosenProducts.length - 1;
        
        const discount = sidebarLevels[positionIndex].dataset.discount;
        const img = sidebarLevels[positionIndex].querySelector('.bundle-product-info img');
        const name = sidebarLevels[positionIndex].querySelector('.bundle-product-meta-info h5');
        const price = sidebarLevels[positionIndex].querySelector('.bundle-product-meta-info .bundle-product-price');

        name.innerText = data.dataset.productName;

        if(choosenSize == 'full-size') {
            img.setAttribute('src', data.dataset.fullImage);
            productVariantIDs.push(data.dataset.fullVariant);
        } else {
            img.setAttribute('src', data.dataset.travelImage);
            productVariantIDs.push(data.dataset.travelVariant);
        }
        
        if(choosenSize == 'full-size') {
            finalPrice = parseFloat(data.dataset.fullPrice) * 0.01;
            totalPricing = totalPricing + parseFloat(finalPrice);
            finalPrice = finalPrice.toFixed(2);
            price.innerText = window.theme.moneyFormat.replace("{{amount}}", finalPrice);
            price.dataset.price = data.dataset.fullPrice;
        } else {
            finalPrice = parseFloat(data.dataset.travelPrice) * 0.01;
            totalPricing = totalPricing + parseFloat(finalPrice);
            finalPrice = finalPrice.toFixed(2);
            price.innerText = window.theme.moneyFormat.replace("{{amount}}", finalPrice);
            price.dataset.price = data.dataset.travelPrice;
        }

        if(discount != 0) {       
            totalPricing = 0;
            savings = 0;
            sidebarLevels.forEach(function(level) {
                let levelFinalprice, levelDiscountPrice, levelFinalPriceFormat, levelDiscountPriceFormat;
                const priceDom = level.querySelector('.bundle-product-meta-info .bundle-product-price');
                levelDiscountPrice = parseFloat(priceDom.dataset.price) * 0.01;
                levelDiscountPrice = levelDiscountPrice.toFixed(2);
                levelDiscountPriceFormat = window.theme.moneyFormat.replace("{{amount}}", levelDiscountPrice);
                levelFinalprice = parseFloat(priceDom.dataset.price) * ((100 - parseFloat(discount)) * 0.01);
                levelFinalprice = levelFinalprice * 0.01;
                if(!isNaN(levelFinalprice)) {
                    totalPricing = parseFloat(totalPricing) + parseFloat(levelFinalprice);
                    savings = savings + (levelDiscountPrice - levelFinalprice);
                }
                levelFinalprice = levelFinalprice.toFixed(2);
                levelFinalPriceFormat = window.theme.moneyFormat.replace("{{amount}}", levelFinalprice);
                priceDom.innerHTML = '<span class="old-price">' + levelDiscountPriceFormat + '</span><span class="discounted-price">' + levelFinalPriceFormat + '</span>';
            });
            totalSavings.innerText = window.theme.moneyFormat.replace("{{amount}}", savings.toFixed(2));
            // discountUnlocked.innerText = discount + '% off unlocked';
            discountUnlocked.innerText = discountUnlocked.dataset.translation.replace('[quantity]', discount);
            if(!bundleDiscountDOM.classList.contains('active')) {
                bundleDiscountDOM.classList.add('active');
            }
        }
        progressData = (positionIndex == 0 ? progressData + 50 : progressData + 110 );
        progressDataMobile = (positionIndex == 0 ? progressDataMobile + 10 : progressDataMobile + 20 );
        progressBar.style.height = progressData + "px";
        progressBarMobile.style.width = progressDataMobile + "%";
        progress = (positionIndex == 0 ? 90 : 110 );
        sidebarLevelsUL.dataset.progress = parseInt(sidebarLevelsUL.dataset.progress) + progress;
        sidebarLevelsULMobile.dataset.progress = parseInt(sidebarLevelsUL.dataset.progress);
        sidebarLevels[positionIndex].classList.add('active');
        sidebarLevelsMobile[positionIndex].classList.add('active');
    }

    function removeProductInfoBundle(indexRemoval) {
        // Remove
        console.log("Remove info");
        totalPricing = 0;
        progressData = 0;
        let finalDiscount, progress;
        const finalIndex = choosenProducts.length - 1;
        sidebarLevels[indexRemoval].classList.remove('active');
        sidebarLevelsMobile[indexRemoval].classList.remove('active');
        const img = sidebarLevels[indexRemoval].querySelector('.bundle-product-info img');
        const name = sidebarLevels[indexRemoval].querySelector('.bundle-product-meta-info h5');
        const price = sidebarLevels[indexRemoval].querySelector('.bundle-product-meta-info .bundle-product-price');

        img.setAttribute('src', '');
        name.innerText = '';
        price.innerHTML = '';

        productVariantIDs.splice(indexRemoval, 1);
        // Re-render
        choosenProducts.forEach(function(el, index) {
            let finalPrice;
            
            finalDiscount = sidebarLevels[index].dataset.discount;
            const imgLvl = sidebarLevels[index].querySelector('.bundle-product-info img');
            const nameLvl = sidebarLevels[index].querySelector('.bundle-product-meta-info h5');
            const priceLvl = sidebarLevels[index].querySelector('.bundle-product-meta-info .bundle-product-price');

            nameLvl.innerText = el.dataset.productName;

            if(choosenSize == 'full-size') {             
                imgLvl.setAttribute('src', el.dataset.fullImage);
            } else {
                imgLvl.setAttribute('src', el.dataset.travelImage);
            }
            
            
            if(choosenSize == 'full-size') {
                finalPrice = parseFloat(el.dataset.fullPrice) * 0.01;
                totalPricing = totalPricing + parseFloat(finalPrice);
                finalPrice = finalPrice.toFixed(2);
                priceLvl.innerText = window.theme.moneyFormat.replace("{{amount}}", finalPrice);
                priceLvl.dataset.price = el.dataset.fullPrice;
            } else {
                finalPrice = parseFloat(el.dataset.travelPrice) * 0.01;
                totalPricing = totalPricing + parseFloat(finalPrice);
                finalPrice = finalPrice.toFixed(2);
                priceLvl.innerText = window.theme.moneyFormat.replace("{{amount}}", finalPrice);
                priceLvl.dataset.price = el.dataset.travelPrice;
            }
            sidebarLevels[index].classList.add('active');
            sidebarLevelsMobile[index].classList.add('active');
        });

        if(finalDiscount != 0) {
            totalPricing = 0;
            savings = 0;
            sidebarLevels.forEach(function(level) {
                let levelFinalprice, levelDiscountPrice, levelFinalPriceFormat, levelDiscountPriceFormat;
                const priceDom = level.querySelector('.bundle-product-meta-info .bundle-product-price');
                levelDiscountPrice = parseFloat(priceDom.dataset.price) * 0.01;
                levelDiscountPrice = levelDiscountPrice.toFixed(2);
                levelDiscountPriceFormat = window.theme.moneyFormat.replace("{{amount}}", levelDiscountPrice);
                levelFinalprice = parseFloat(priceDom.dataset.price) * ((100 - parseFloat(finalDiscount)) * 0.01);
                levelFinalprice = levelFinalprice * 0.01;
                if(!isNaN(levelFinalprice)) {
                    totalPricing = parseFloat(totalPricing) + parseFloat(levelFinalprice);
                    savings = savings + (levelDiscountPrice - levelFinalprice);
                }
                levelFinalprice = levelFinalprice.toFixed(2);
                levelFinalPriceFormat = window.theme.moneyFormat.replace("{{amount}}", levelFinalprice);
                priceDom.innerHTML = '<span class="old-price">' + levelDiscountPriceFormat + '</span><span class="discounted-price">' + levelFinalPriceFormat + '</span>';
            });
            totalSavings.innerText = window.theme.moneyFormat.replace("{{amount}}", savings.toFixed(2));
            // discountUnlocked.innerText = finalDiscount + '% off unlocked';
            discountUnlocked.innerText = discountUnlocked.dataset.translation.replace('[quantity]', finalDiscount);
        } else {
            if(bundleDiscountDOM.classList.contains('active')) {
                bundleDiscountDOM.classList.remove('active');                
            }
        }
        if(finalIndex >= 0) {
            sidebarLevels[finalIndex+1].classList.remove('active');
            sidebarLevelsMobile[finalIndex+1].classList.remove('active');
        }
        
        progress = (finalIndex < 0 ? 0 : (finalIndex == 0 ? 90 : (finalIndex * 110) + 90));
        progressData = (finalIndex < 0 ? 0 : (finalIndex == 0 ? 50 : (finalIndex * 110) + 50));
        progressBar.style.height = progressData + "px";
        progressDataMobile = (finalIndex < 0 ? 0 : (finalIndex == 0 ? 10 : (finalIndex * 20) + 10));
        progressBar.style.height = progressData + "px";
        progressBarMobile.style.width = progressDataMobile + "%";
        sidebarLevelsUL.dataset.progress = progress;
        sidebarLevelsULMobile.dataset.progress = progress;
    }

    //Remove btns
    removeBtns.forEach(function(btn, index) {
        removeBtnsArr[index] = btn;

        removeBtnsArr[index].addEventListener('click', function(e) {
            e.preventDefault();
            
            const getIndex = this.dataset.removeIndex;
            choosenProducts[getIndex].click();
        });
    });

    //Filter     
    const bundleProductsToFilter = document.querySelectorAll('.grid-collection-bundle .product-item');
    const bundleFilters = document.querySelectorAll('.bundle-collection-tabs-inner .collection-tab');
    let activeFilter = document.querySelector('.bundle-collection-tabs-inner .collection-tab.active');
    const filtersArr = [];

    if(bundleProductsToFilter.length > 0) {
        bundleFilters.forEach(function(filter, index) {
            filtersArr[index] = filter;
            filtersArr[index].addEventListener('click', function() {                
                if(activeFilter.dataset.filter != this.dataset.filter) {                    
                    activeFilter.classList.remove('active');
                    activeFilter = this;
                    activeFilter.classList.add('active');
                    mobileFilter.value = this.dataset.filter;

                    if(this.dataset.filter != "all") {
                        bundleGrid.classList.add('active-filter');
                        bundleProductsToFilter.forEach(function(el) {
                            if(activeFilter.dataset.filter == el.dataset.collection) {
                                el.classList.add('active');
                            } else {
                                el.classList.remove('active');
                            }
                        });
                    } else {
                        bundleGrid.classList.remove('active-filter');
                        bundleProductsToFilter.forEach(function(el) {
                            el.classList.remove('active');
                        });
                    }
                }
            });
        });

        mobileFilter.addEventListener("change", function() {
            const filterValue = this.value;
            if(this.value != "all") {
                bundleGrid.classList.add('active-filter');
                bundleProductsToFilter.forEach(function(el) {
                    if( filterValue == el.dataset.collection) {
                        el.classList.add('active');                        
                    } else {
                        el.classList.remove('active');
                    }
                });
                
                bundleFilters.forEach(function(el) {
                    if( filterValue == el.dataset.filter) {
                        el.classList.add('active');
                        activeFilter = el;
                    } else {
                        el.classList.remove('active');
                    }
                });
            } else {
                bundleGrid.classList.remove('active-filter');
                bundleFilters[0].classList.add('active');
                bundleProductsToFilter.forEach(function(el) {
                    el.classList.remove('active');
                });
            }
        });
    }

    nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var cartURL = this.dataset.cartUrl || '/cart';
        const backUpHTML = this.innerHTML;
        this.disabled = true;
        this.innerHTML = '<span class="loader"></span>';
        const timeId = Date.now();
        let formData = {
            items: []
        }

        productVariantIDs.forEach(function(vid) {
            formData.items.push({
                "id": vid,
                "quantity": 1,
                "properties": {
                    "_bundle_builder": "yes",
                    "_bundleId": timeId
                }
            });
        });
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
            this.innerHTML = backUpHTML;
            this.disabled = false;
        }).then((data) => {
            
            const total_price = data.items.reduce((accumulator, item) => {
                return item.final_price + accumulator;
            }, 0);
            data.total_price = total_price;
            var cart = {
                cart: data
            };
            var detail = {
                detail: cart
            };
            var event = new CustomEvent('cart:updated', detail);
            document.dispatchEvent(event);

            this.innerHTML = "bundle added";
            this.disabled = true;
            refreshCart.call(cartInstance);
            // openCart.call(cartInstance);

            setTimeout(function() {
                window.location.replace(cartURL);
            }, 1500);
        });

        
    })    


    // Drag scroll
    const container = document.querySelector('#items-container');
                
    let startY;
    let startX;
    let scrollLeft;
    let scrollTop;
    let isDown;

    container.addEventListener('mousedown',e => mouseIsDown(e));  
    container.addEventListener('mouseup',e => mouseUp(e))
    container.addEventListener('mouseleave',e=>mouseLeave(e));
    container.addEventListener('mousemove',e=>mouseMove(e));

    function mouseIsDown(e){
        isDown = true;
        startY = e.pageY - container.offsetTop;
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
        scrollTop = container.scrollTop; 
    }

    function mouseUp(e){
        isDown = false;
    }

    function mouseLeave(e){
        isDown = false;
    }
    function mouseMove(e){
        if(isDown){
            e.preventDefault();
            //Move vertcally
            const y = e.pageY - container.offsetTop;
            const walkY = y - startY;
            container.scrollTop = scrollTop - walkY;

            //Move Horizontally
            const x = e.pageX - container.offsetLeft;
            const walkX = x - startX;
            container.scrollLeft = scrollLeft - walkX;

        }
    }

    //Open learn more
    quickViewBtn.forEach(function(el, index) {
        quickViewBtnArr[index] = el;

        quickViewBtnArr[index].addEventListener('click', function(e) {
            e.preventDefault();
            const prodUrl = this.dataset.url;
            const prodTitle = this.dataset.productTitle;
        
            window.emit("quick-view:open", null, {
                type: "quick-view",
                productUrl: prodUrl,
                productTitle: prodTitle
            });
        });
    });

    document.addEventListener("quick-view:loaded", function (e) {
        let searchTerm = (choosenSize == 'full-size' ? 'Full' : "Travel");
        const variantsBtn = e.target.querySelectorAll('.dynamic-variant-input-wrap button');

        if(variantsBtn.length > 0) {
            variantsBtn.forEach(function(el) {
                const btnValue = el.dataset.optionValue;

                if(btnValue.indexOf(searchTerm) !== -1) {
                    console.log(btnValue);
                    setTimeout(function() {
                        el.click();
                    }, 300)
                }
            });
        }        
    });
});